export type FlagKey = 'WEBHOOKS' | 'INVITATIONS';

export type Environments = 'dev' | 'staging' | 'prod';

export type EnvFlag = {
  [env in Environments]: boolean;
};

export type FeatureFlags = {
  [key in FlagKey]: EnvFlag;
};

export const featureFlags: FeatureFlags = {
  WEBHOOKS: {
    dev: true,
    staging: true,
    prod: true,
  },
  INVITATIONS: {
    dev: true,
    staging: false,
    prod: false,
  },
};
